/**
 * モバイル (touch) ドラッグ時の視覚 Y オフセット (SVG 仮想座標)。
 *
 * BadgeSvg.tsx で <g transform> の Y に `-TOUCH_DRAG_OFFSET_Y` を加算する (視覚)。
 * useFingeringEditorCore.ts の finalizeDrag で applyTouchOffset === true のとき
 * `dragDelta.dy -= TOUCH_DRAG_OFFSET_Y` で「視覚位置にドロップ」 (P-2、 issue #28 v3) を実現。
 *
 * SVG_HEIGHT=842 に対して 18 (約 2.1%)、 zoom 100% で約 17 px、 174% で約 30 px。
 *
 * spec: docs/superpowers/specs/2026-05-27-issue-28-jsdom-gap-investigation.md §7.5.1 (P-2 採用)
 * plan: docs/superpowers/plans/2026-05-27-mobile-drag-offset-drop-position-fix-v3.md
 */
export const TOUCH_DRAG_OFFSET_Y = 18;
